import { useModalContext } from 'utils/contexts/modal';
import { DataSyncModalAction, DataSyncModalState } from '../contexts/ModalContext';
import { ArchiveDestinationModal } from './modals/ArchiveDestinationModal';

export const DataSyncModals = () => {
  const { modalState } = useModalContext<DataSyncModalState>();

  if (!modalState) return null;

  const { action } = modalState;

  switch (action) {
    case DataSyncModalAction.ARCHIVE_DESTINATION:
      return <ArchiveDestinationModal />;
    default:
      return null;
  }
};
